<template>
  <div class="Container" v-if="$mq == 'desktop'">
    <div class="top-title">
      <div class="TileList-Infos" @click="toggle">
        <div class="blur"></div>
        <div class="TileList-Details">
          <div class="TileList-Subtitle">{{ subtitle }}</div> 
        </div>
      </div>

      <!-- Center item -->
      <div
        :class="{
          'TileList-Progress-Wrapper': true,
          'Slot-Open': open
          }"
      >
        <!-- <div class="TileList-Subline">{{ subline }}</div> -->

        <slot name="center"></slot>
      </div>

      <div :class="{ 'TileList-Slot-Container': true, 'Slot-Open': open }">
        <div class="TileList-Slot-Spacer"></div>
        <slot></slot>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="top-title">
      <div class="TileList-Infos" @click="toggle">
        <div class="blur"></div>
        <div class="TileList-Details">
          <div class="TileList-Subtitle">{{ subtitle }}</div> 
        </div>
      </div>
      <div
        :class="{
          'TileList-Progress-Wrapper': true,
          'Slot-Open': open
          }"
      >
        <slot name="center"></slot>
      </div>
      <div :class="{ 'TileList-Slot-Container': true, 'Slot-Open': open }">
        <div class="TileList-Slot-Spacer"></div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import VvProgressBar from './VvProgressBar'
import DownChevronIcon from '@/components/layout/svg/DownChevronIcon'

const Status = {
  Complete: 'complete',
  Running: 'running',
  Unstarted: 'unstarted'
}

export default {
  name: 'VvDesktopTileList',
  components: { VvProgressBar, DownChevronIcon },
  props: {
    subtitle: {
      type: String,
      required: false
    },
    subline: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    progression: {
      type: Number,
      required: false,
      default: 0
    },
    total: {
      type: Number,
      required: false,
      default: 0
    },
    default: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      open: this.default
    }
  },
  computed: {
    status() {
      if (this.progression === 0) return Status.Unstarted

      return this.progression === this.total ? Status.Complete : Status.Running
    },
    statusLabel() {
      return this.$t(`lessonStep.lesson_item.status.${this.status}`)
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Container {
  display: flex;
  flex-direction: column;
  border-radius: 60px 60px 0px 0px;
  background-color: #fff;
  margin-top: -60px;
}
.top-title {
  overflow: hidden;
  padding: 10px 0;
  user-select: none;
  min-height: 50px;

  // Left item
  .TileList-Infos {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    background-color: $primary-alt;
    padding: 5px 0px 5px 20px;
    border-radius: 5px;
    // margin-top: 60px;
    @media (min-width: 450px) {
      margin-top: 60px;
      margin-left: 40px;
      margin-right: 40px;
    }

    .TileList-Details {
      display: flex;
      min-height: 30px;
      flex-direction: column;
      justify-content: center;
      width: 50%;
      z-index: 1;

      .TileList-Title {
        font-size: 14px;
        font-weight: bold;
        color: $primary;
        margin-bottom: 8px;
      }

      .TileList-Subtitle {
        font-size: 14px;
        font-weight: 900;
        color: $font-banner;
      }

      .TileList-Subline {
        font-size: 9px;
        font-weight: 500;
        color: $font-banner;
      }
    }
  }

  // Center item
  .TileList-Progress-Wrapper {
    display: none;
    flex-direction: column;
    flex-grow: 1;
    margin: 10px 0 20px 10px;

    &.Slot-Open {
      display: flex;
    }

    .TileList-Progress-Status {
      font-weight: bold;
      font-size: 14px;

      &.Status-Unstarted {
        color: $dark;
      }

      &.Status-Running {
        color: $primary;
      }

      &.Status-Complete {
        color: #5ad691;
      }
    }

    .TileList-Progress {
      width: 33%;
    }
  }

  // Right item
  .TileList-Icon-Wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-width: 10%;

    .TileList-Icon {
      font-size: 20px;
      font-weight: bold;
      transform: rotate(180deg);
      background-color: white;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 200ms ease-in-out;
      text-align: center;

      svg {
        width: 17px;
        left: -1px;
        position: relative;
      }

      &.Icon-Open {
        transform: rotate(0deg) translateX(0px);
        svg {
          left: 0px;
        }
      }
    }
  }

  .TileList-Slot-Container {
    overflow: hidden;
    height: 0px;
    transition: height 1s ease-in-out;

    &.Slot-Open {
      height: auto;
    }

    .TileList-Slot-Spacer {
      height: 100%;
    }
  }
}

.blur {
  height: auto;
  width: 100%;
  filter: blur(1px);
  position: absolute;
  left: 0px;
  bottom: 0px;
  background-color: $primary-alt;
  border-radius: 10px;
  overflow: auto;
}
</style>
